<template>
    <div class="main-card">
        <div class="card">
            <div class="card-header bg-success">
                <h5 class="text-white cursor-pointer m-0" @click="() => collapseSidebar('toggleWatchlist')">
                    <i class="fas fa-list-ul"></i>
                    <span> {{ $t('pages.watchlist') }}</span>
                    <a class="pull-right" data-toggle="dropdown">
                        <span>
                            <i class="fa" :class="{
                                'fa-angle-up': !this.form.toggleWatchlist,
                                'fa-angle-down': this.form.toggleWatchlist
                            }"></i>
                        </span>
                    </a>
                </h5>
            </div>
            <div class="card-body" v-if="!this.form.toggleWatchlist">
                <div class="col-md-5">
                    <el-select class="w-100" v-model="searchSector" clearable :placeholder="$t('sector_types.title')"
                        @change="gotoFilter()">
                        <el-option v-for="item in filterSectorOptions" :key="item.value" :label="item.text"
                            :value="item.value">
                            <span>{{ item.text }}</span>
                            <span class="right-align">
                                <i :class="getSectorIcons(`${item.value}`)"></i>
                            </span>
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-5 mt-2">
                    <el-select class="w-100" v-model="searchType" clearable :placeholder="$t('business_types.title')"
                        @change="gotoFilter()">
                        <el-option v-for="item in filterTypeOptions" :key="item.code" :label="item.name"
                            :value="item.code">
                            <span>{{ item.name }}</span>
                            <span class="right-align">
                                <i :class="getTypeIcons(`${item.code}`)"></i>
                            </span>
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-5 mt-2">
                    <custom-checkbox id="bCheckbox"
                        :label="$t('indicators.buffett') + ' (' + displayPercentage(`${bValue}`) + ')'"
                        :value="isYardstick" @change="gotoFilter">
                    </custom-checkbox>
                </div>
                <loading-container :loading="form.watchlistLoading">
                    <div v-if="watchlist.total > 0">
                        <span class="pull-right">{{ $t('total') }}: {{ watchlist.total }}</span>
                        <table class="table table-bordered watchlist-table sticky-table">
                            <thead class="border-dark">
                                <tr vertical-align="baseline">
                                    <th style="width: 12%" class="th-sort">
                                        <i class="fas fa-chart-line"></i>
                                        <span class="hidden-sm-up"> {{ $t('stocks.code') }}</span>
                                        <span class="hidden-xs-down"> {{ $t('stocks.code') }}</span>

                                    </th>
                                    <th style="width: 12%" class="th-sort"
                                        :class="(sortWL.field === 'dca' && sortWL.order) ? (sortWL.order === 'desc' ? 'descending' : 'ascending') : ''"
                                        @click="onSortWatchlist('dca')">
                                        <IconTooltip :iconClass="getFeatureIcons('dca')"
                                            :text="getFeatureNames('dca')" />
                                        <span class="hidden-sm-up"> {{ getFeatureNames('dca') }}</span>
                                        <span class="hidden-xs-down"> {{ getFeatureNames('dca') }}</span>
                                    </th>
                                    <th style="width: 14%" class="th-sort"
                                        :class="(sortWL.field === 'mos' && sortWL.order) ? (sortWL.order === 'desc' ? 'descending' : 'ascending') : ''"
                                        @click="onSortWatchlist('mos')">
                                        <IconTooltip :iconClass="getFeatureIcons('mos')"
                                            :text="getFeatureNames('mos')" />
                                        <span class="hidden-sm-up"> {{ getFeatureNames('mos') }}</span>
                                        <span class="hidden-xs-down"> {{ getFeatureNames('mos') }}</span>
                                    </th>
                                    <th style="width: 14%" class="th-sort"
                                        :class="(sortWL.field === 'beta' && sortWL.order) ? (sortWL.order === 'desc' ? 'descending' : 'ascending') : ''"
                                        @click="onSortWatchlist('beta')">
                                        <IconTooltip :iconClass="getFeatureIcons('beta')"
                                            :text="getFeatureNames('beta')" />
                                        <span class="hidden-sm-up"> {{ getFeatureNames('beta') }}</span>
                                        <span class="hidden-xs-down"> {{ getFeatureNames('beta') }}</span>
                                    </th>
                                    <th style="width: 14%" class="th-sort"
                                        :class="(sortWL.field === 'dividend' && sortWL.order) ? (sortWL.order === 'desc' ? 'descending' : 'ascending') : ''"
                                        @click="onSortWatchlist('dividend')">
                                        <IconTooltip :iconClass="getFeatureIcons('dividend')"
                                            :text="getFeatureNames('dividend')" />
                                        <span class="hidden-sm-up"> {{ getFeatureNames('dividend') }}</span>
                                        <span class="hidden-xs-down"> {{ getFeatureNames('dividend') }}</span>
                                    </th>
                                    <th style="width: 10%" class="th-sort">
                                        <i class="fas fa-shield-alt"></i>
                                        <span class="hidden-sm-up"> {{ $t('business_types.title') }}</span>
                                        <span class="hidden-xs-down"> {{ $t('business_types.title') }}</span>
                                    </th>
                                    <th style="width: 10%" class="th-sort">
                                        <i class="fas fa-industry"></i>
                                        <span class="hidden-sm-up"> {{ $t('sector_types.title') }}</span>
                                        <span class="hidden-xs-down"> {{ $t('sector_types.title') }}</span>
                                    </th>
                                    <th class="th-sort">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="height: 15px" v-for="(row, index) in watchlist.items" :key="index">
                                    <td style="width: 15%">
                                        <p>
                                            {{ row.code }}
                                            <span class="text-blue pull-right medium-icon">
                                                <span class=" m-r-5" v-if="row.hasData"
                                                    @click="() => linkToStockInfo(row.code, true)">
                                                    <i class="mdi mdi-launch cursor-pointer"></i>
                                                </span>
                                                <span @click="() => displayCandleChart(row.code)">
                                                    <i class="fas fa-chart-line cursor-pointer"></i>
                                                </span>
                                            </span>
                                        </p>
                                        <span v-if="row.marketPrice" class="price-change box-120"
                                            :class="{ 'positive': row.marketPrice.priceChange > 0, 'negative': row.marketPrice.priceChange < 0 && row.marketPrice.value > row.marketPrice.floor, 'neutral': row.marketPrice.priceChange === 0, 'ceil': row.marketPrice.value >= row.marketPrice.ceil, 'floor': row.marketPrice.value <= row.marketPrice.floor }">
                                            <span>
                                                <i
                                                    :class="{ 'fas fa-arrow-up': row.marketPrice.priceChange > 0, 'fas fa-arrow-down': row.marketPrice.priceChange < 0, 'fas fa-minus': row.marketPrice.priceChange === 0 }"></i>
                                                {{ row.marketPrice.value | numberDisplay }}
                                            </span>
                                            <span>{{ row.marketPrice.perChange / 100 | percentDisplay }} </span>
                                        </span>
                                    </td>
                                    <td>{{ row.dca_score | numberDisplayFloat(1) }}</td>
                                    <td>{{ row.mos | percentDisplay() }}</td>
                                    <td>{{ row.beta }}</td>
                                    <td>{{ row.dividend | percentDisplay() }}</td>
                                    <td>
                                        <IconTooltip :iconClass="getTypeIcons(`${row.type}`)"
                                            :text="getBusinessTypeText(`${row.type}`)" />
                                    </td>
                                    <td>
                                        <IconTooltip :iconClass="getSectorIcons(`${row.sector_code}`)"
                                            :text="getSectorText(`${row.sector_code}`)" />
                                    </td>
                                    <td>
                                        <span>
                                            <p
                                                @click="() => onRemoveWatchlist({ code: row.code, payload: filterPayload }, true)">
                                                <i class="fas fa-eye-slash cursor-pointer text-blue"></i>
                                            </p>
                                            <p v-if="!row.hasData" @click="() => submitRequest(row.code)">
                                                <i class="fas fa-plus-square text-blue cursor-pointer action-icon"></i>
                                            </p>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="row m-t-20 m-l-10">
                        {{ $t('messages.filter_no_result') }}
                    </div>
                </loading-container>
                <div v-if="showCandleChart === true">
                    <CandleStick :symbol="symbol" @close="showCandleChart = false" />
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header bg-success">
                <h5 class="text-white cursor-pointer m-0" @click="() => collapseSidebar('toggleDashboard')">
                    <i class="icon-speedometer"></i>
                    <span> {{ $t('dashboard') }}</span>
                    <a class="pull-right" data-toggle="dropdown">
                        <span>
                            <i class="fa" :class="{
                                'fa-angle-up': !this.form.toggleDashboard,
                                'fa-angle-down': this.form.toggleDashboard
                            }"></i>
                        </span>
                    </a>
                </h5>
            </div>
            <div class="card-body" v-if="!this.form.toggleDashboard">
                <ul class="nav nav-tabs customtab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'mos' }"
                            @click="() => onSelectedTab('mos')">

                            <i class="far fa-life-ring"></i>
                            <span class="hidden-sm-up"> {{ $t('stocks.valuation.title') }}</span>
                            <span class="hidden-xs-down"> {{ $t('stocks.valuation.title') }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'dca' }"
                            @click="() => onSelectedTab('dca')">
                            <i class="fas fa-chess-queen"></i>
                            <span class="hidden-sm-up"> {{ $t('stocks.dca.title') }}</span>
                            <span class="hidden-xs-down"> {{ $t('stocks.dca.title') }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'beta' }"
                            @click="() => onSelectedTab('beta')">
                            <i class="fab fa-behance"></i>
                            <span class="hidden-sm-up"> {{ $t('beta_types.title') }}</span>
                            <span class="hidden-xs-down"> {{ $t('beta_types.title') }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'sector' }"
                            @click="() => onSelectedTab('sector')">
                            <i class="fas fa-industry"></i>
                            <span class="hidden-sm-up"> {{ $t('sector_types.title') }}</span>
                            <span class="hidden-xs-down"> {{ $t('sector_types.title') }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'business_type' }"
                            @click="() => onSelectedTab('business_type')">
                            <i class="fas fa-shield-alt"></i>
                            <span class="hidden-sm-up"> {{ $t('business_types.title') }}</span>
                            <span class="hidden-xs-down"> {{ $t('business_types.title') }}</span>
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <!-- mos -->
                    <div class="tab-pane" :class="{ active: this.selectedTab === 'mos' }">
                        <loading-container :loading="form.donutMOSLoading">
                            <div class="card-body">
                                <div class="row">
                                    <div class="align-items-center m-t-20 m-b-20 p-positive col-md-5 col-lg-4">
                                        <div id="donutMOS">
                                            <apexchart type="donut" :options="donutChartMOS.chartOptions"
                                                :series="donutChartMOS.series">
                                            </apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </loading-container>
                    </div>
                    <!-- dca -->
                    <div class="tab-pane" :class="{ active: this.selectedTab === 'dca' }">
                        <loading-container :loading="form.donutDCALoading">
                            <div class="card-body">
                                <div class="row">
                                    <div class="align-items-center m-t-20 m-b-20 p-positive col-md-5 col-lg-4">
                                        <div id="donutDCA">
                                            <apexchart type="donut" :options="donutChartDCA.chartOptions"
                                                :series="donutChartDCA.series">
                                            </apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </loading-container>
                    </div>
                    <!-- beta -->
                    <div class="tab-pane" :class="{ active: this.selectedTab === 'beta' }">
                        <loading-container :loading="form.donutBetaLoading">
                            <div class="card-body">
                                <div class="row">
                                    <div class="align-items-center m-t-20 m-b-20 p-positive col-md-5 col-lg-4">
                                        <div id="donutBeta">
                                            <apexchart type="donut" :options="donutChartBeta.chartOptions"
                                                :series="donutChartBeta.series">
                                            </apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </loading-container>
                    </div>
                    <!-- sector -->
                    <div class="tab-pane" :class="{ active: this.selectedTab === 'sector' }">
                        <loading-container :loading="form.donutSectorLoading">
                            <div class="card-body">
                                <div class="row">
                                    <div class="align-items-center m-t-20 m-b-20 p-positive col-md-5 col-lg-4">
                                        <div id="donutSector">
                                            <apexchart type="donut" :options="donutChartSector.chartOptions"
                                                :series="donutChartSector.series"></apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </loading-container>
                    </div>
                    <!-- business_type -->
                    <div class="tab-pane" :class="{ active: this.selectedTab === 'business_type' }">
                        <loading-container :loading="form.donutTypeLoading">
                            <div class="card-body">
                                <div class="row">
                                    <div class="align-items-center m-t-20 m-b-20 p-positive col-md-5 col-lg-4">
                                        <div id="donutBType">
                                            <apexchart type="donut" :options="donutChartBusinessType.chartOptions"
                                                :series="donutChartBusinessType.series"></apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </loading-container>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from "vuex";
import BarChart from "@/components/Chart/BarChart.js";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import StockIconType from "@/components/Common/StockIconType";
import Headline from '@/components/Common/Headline.vue'
import LinkButton from "@/components/Misc/LinkButton";
import Modal from "@/components/Misc/Modal";
import CustomCheckbox from '@/components/Common/CustomCheckbox';
import common from "@/libs/common";
import helper from "@/libs/helper";
import CandleStick from '../../../components/Chart/CandleStick.vue';
import IconTooltip from '../../../components/Common/IconTooltip.vue';

export default {
    name: "Watchlist",
    components: {
        IconTooltip,
        CustomCheckbox,
        BarChart,
        LoadingContainer,
        StockIconType,
        Headline,
        LinkButton,
        CandleStick,
        Modal
    },
    beforeMount() {
        this.getDonutChartByType({ method: 'mos' });
        this.getBValue();
        this.filterWatchlist(this.filterPayload);
        if (!this.sectors.length) {
            this.getRankingSectors();
        };
    },
    data() {
        return {
            showCandleChart: false,
            searchSector: '',
            searchType: '',
            isYardstick: false,
            selectedTab: "mos",
            // bIndicatorLabel: `${i18n.t('indicators.buffett')} - ${this.bValue}`,
            filterPayload: {
                search: "",
                sort: {
                    field: "mos",
                    order: "desc"
                },
                filter: {
                    types: [],
                    sectors: [],
                    yardstick: false
                },
                page: 1,
                limit: 100
            },
        };
    },
    computed: {
        ...mapGetters({
            chartOptions: "dashboard/chartOptions",
            chartBar: "dashboard/chartBar",
            watchlist: "home/watchlist",
            form: "home/form",
            industry: "home/industry",
            sort: "home/sort",
            sortWL: "home/sortWL",
            donutChartMOS: "home/donutChartMOS",
            donutChartDCA: "home/donutChartDCA",
            donutChartBeta: "home/donutChartBeta",
            donutChartBusinessType: "home/donutChartBusinessType",
            donutChartSector: "home/donutChartSector",
            bIndChart: "home/bIndChart",
            s2bIndChart: "home/s2bIndChart",
            sectors: "ranking/sectors",
            bValue: "common/bIndicator"
        }),
        filterTypeOptions() {
            return common.getTypeOptions();
        },
        filterSectorOptions() {
            return this.sectors;
        },
    },
    methods: {
        ...mapActions({
            filterWatchlist: "home/filterWatchlist",
            setDefaultCode: "configuration/setDefaultCode",
            onRemoveWatchlist: "home/onRemoveWatchlist",
            getStockSameIndustryV2: "stock/getStockSameIndustryV2",
            setField: "home/setField",
            setSortField: "home/setSortField",
            setSortWLField: "home/setSortWLField",
            getDonutChartByType: "home/getDonutChartByType",
            getBIndicator: "home/getBIndicator",
            getS2BIndicator: "home/getS2BIndicator",
            getRankingSectors: "ranking/getSectors",
            getBValue: "common/getBIndicator",
            requestNewStock: "stock/requestNewStock",
        }),
        getFeatureIcons(code) {
            return common.getFeatureIcons(code);
        },
        getFeatureNames(code) {
            return common.getFeatureNames(code);
        },
        getTypeIcons(code) {
            return common.getTypeIcons(code);
        },
        getSectorIcons(code) {
            return common.getSectorIcons(code);
        },
        getSectorText(code) {
            return common.getSectorText(code);
        },
        getBusinessTypeText(code) {
            return common.getBusinessTypeText(code);
        },
        displayCandleChart(symbol) {
            this.symbol = symbol;
            this.showCandleChart = true;
        },
        submitRequest(code) {
            if (code) {
                this.requestNewStock(code);
            }
        },
        displayPercentage(value) {
            return helper.percentDisplay(value, 'N/A');
        },
        gotoFilter(isChecked) {
            if (this.searchSector) {
                this.filterPayload.filter['sectors'] = [this.searchSector]
            } else {
                this.filterPayload.filter['sectors'] = [];
            }
            if (this.searchType) {
                this.filterPayload.filter['types'] = [this.searchType]
            } else {
                this.filterPayload.filter['types'] = [];
            }
            if (isChecked == true) {
                this.isYardstick = isChecked;
            } else if (isChecked == false) {
                this.isYardstick = false;
            }
            this.filterPayload.filter['yardstick'] = this.isYardstick;
            this.filterWatchlist(this.filterPayload);
        },
        getTypeIcons(iconCode) {
            return common.getTypeIcons(iconCode);
        },
        getSectorIcons(iconCode) {
            return common.getSectorIcons(iconCode);
        },
        onSelectedTab(key) {
            this.selectedTab = key;
            this.getDonutChartByType({ method: this.selectedTab });
        },
        onSortWatchlist(sortField) {
            this.filterPayload.sort['field'] = sortField;
            this.filterPayload.sort['order'] = this.sortWL.order === 'asc' ? 'desc' : 'asc';
            if (sortField !== this.sort.field) {
                this.sortWL['field'] = sortField;
            }
            if (this.sortWL.order === 'asc') {
                this.sortWL['order'] = "desc";
            } else {
                this.sortWL['order'] = "asc";
            }
            this.filterWatchlist(this.filterPayload);
        },
        onSortField(sortField) {
            if (sortField === this.sort.field) {
                this.setSortField({ key: 'order', value: this.sort.order === 'asc' ? 'desc' : 'asc' });
            }
            this.setSortField({ key: 'field', value: sortField });
            this.getStockSameIndustryV2(this.industry[0].code);
        },
        linkToStockInfo(code, isNewtab) {
            this.setDefaultCode(code);

            if (isNewtab) {
                let routeData = this.$router.resolve({ name: 'overview', params: { codeId: code } });
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({ name: 'overview', params: { codeId: code } }).catch(() => { });
            }
        },
        valueFilter(value, isDca) {
            if (isDca) {
                return _.round(value, 1);
            }
            return _.round(value * 100, 1) + '%';
        },
        actionGetSameIndustry(key, code) {
            this.collapseSidebar(key);
            this.getStockSameIndustryV2(code);
        },
        collapseSidebar(key) {
            this.setField({ key: key, value: !this.form[key] });
        },
    }
};
</script>

<style scoped>
.ti-close {
    position: absolute;
    right: -12px;
    top: -13px;
    font-weight: bold;
    background: #fff;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    opacity: 0.5;
    transition: ease-in;
}

.ti-close:hover {
    opacity: 1;
    transition: ease-in;
}

.bg-gray {
    background-color: #ddd;
}

td small {
    vertical-align: super;
}

.th-sort {
    position: relative;
    vertical-align: top;
    cursor: pointer;
}

.descending:after {
    content: "\2193";
}

.ascending:after {
    content: "\2191";
}

.ascending:after,
.descending:after {
    display: inline-block;
}

.headline-row {
    display: flex;
    gap: 10px;
    align-items: center;
}

@media only screen and (max-width: 768px) {

    table.watchlist-table th,
    table.watchlist-table td {
        font-size: 12px;
        padding: 10px;
    }
}

@media only screen and (max-width: 500px) {

    table.watchlist-table th,
    table.watchlist-table td {
        font-size: 12px;
        padding: 5px;
    }
}

@media only screen and (max-width: 768px) {

    table.compare-stock-table th,
    table.compare-stock-table td {
        font-size: 12px;
        padding: 10px;
    }
}

@media only screen and (max-width: 500px) {

    table.compare-stock-table th,
    table.compare-stock-table td {
        font-size: 11px;
        padding: 2px;
    }
}
</style>